// QA check with HW

import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {ComputerCsvImportRequest, ComputerRequest, ComputerResponse,} from '../../../../contracts/v0/inventory/computer.contracts';
import {ApiV0Inventory} from '../api.v0.inventory';

export class ApiV0Computer {
    segment: string;

    constructor(v0: ApiV0Inventory, private rest: RestApiService) {
        this.segment = v0.segment + '/computer';
    }

    list(): Observable<BaseCollectionModel<ComputerResponse>> {
        return this.rest.get<BaseCollectionModel<ComputerResponse>>(`${this.segment}/list`, ComputerResponse)
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<ComputerResponse>> {
        return this.rest.post<SearchModel, BaseCollectionModel<ComputerResponse>>(`${this.segment}/search`, ComputerResponse, searchModel)
    }

    detail(guid: string): Observable<ComputerResponse> {
        return this.rest.get(`${this.segment}/details/${guid}`, ComputerResponse)
    }

    create(createRequest: ComputerRequest) {
        return this.rest.post<ComputerRequest, ComputerResponse>(`${this.segment}/create`, ComputerResponse, createRequest)
    }

    update(updateRequest: ComputerRequest) {
        return this.rest.patch<ComputerRequest, ComputerResponse>(`${this.segment}/update`, ComputerResponse, updateRequest)
    }

    delete(guid: string) {
        return this.rest.delete<void>(`${this.segment}/delete/${guid}`)
    }

    importCsvData(data: ComputerCsvImportRequest): Observable<BaseCollectionModel<ComputerResponse>> {
        return this.rest.post<ComputerCsvImportRequest, BaseCollectionModel<ComputerResponse>>(
            `${this.segment}/import/csv`,
            ComputerResponse,
            data
        )
    }

    importExcelData(data: ComputerCsvImportRequest): Observable<BaseCollectionModel<ComputerResponse>> {
        return this.rest.post<ComputerCsvImportRequest, BaseCollectionModel<ComputerResponse>>(
            `${this.segment}/import/excel`,
            ComputerResponse,
            data
        )
    }

    typeSelectionList(): Observable<BaseCollectionModel<string>> {
        return this.rest.get<BaseCollectionModel<string>>(`${this.segment}/typeSelectionList`)
    }
}

